import React from 'react';
import sellerImg from '../assets/seller.png';
import stallImg from '../assets/stall.png';
import './Seller.css';

const Seller = () => {
  return (
    <div className="seller-stall-wrapper">
      <img src={stallImg} alt="Stall" className="stall-img" />
      <img src={sellerImg} alt="Seller" className="seller-beside" />
    </div>
  );
};

export default Seller;
